import type { SvgIconProps } from "@mui/material"
import { SvgIcon } from "@mui/material"

export function DownloadLine(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 12 13" {...props}>
      <path
        d="M0 11.6663H12V12.9997H0V11.6663ZM6.66667 7.78101L10.714 3.73301L11.6567 4.67567L6 10.333L0.343333 4.67634L1.286 3.73301L5.33333 7.77967V0.333008H6.66667V7.78101Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
